import React from 'react'
import styled from '@emotion/styled'
import { css } from 'emotion'
import { NavLink } from 'react-router-dom'
import InlineSVG from 'svg-inline-react'
import { useHistory } from 'react-router-dom'

import iconBack from 'assets/icons/ico-back.svg'

const NavbarContainer = styled.nav`
  min-width: 214px;
  height: 100%;
  background-color: #28282E;
  color: #90A1B0;
  padding: 16px;
  width: 13.375%;
`
const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-top: 20px;
`
const Icon = styled(InlineSVG)`
  transform: scale(.68);
`
const GoBackWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  opacity: .8;
  cursor: pointer;
  transition: opacity .2s ease;
  
  &:hover {
    opacity: 1;
  }
`
const GoBackTitle = styled.div`
  margin-left: 6px;
  margin-bottom: 3px;
  color: #ffffff;
  font-size: 14px;
`
const NavbarItems = styled.div`
  margin-top: 10px;
`
const NavLinkStyled = styled(NavLink)`
  border-radius: 4px;
  padding: 8px;
  height: 30px;
  display: flex;
  align-items: center;
  
  cursor: pointer;
  transition: all .2s ease;
  
   &:hover{
    background-color: #90A1B0;
    color: #FFFFFF;
  }
`
const activeItem = css`
  background-color: #E50870;
  color: #FFFFFF;
`

const navbarItems = [
  { title: 'Inboxes', route: 'inboxes' },
  { title: 'Organisations', route: 'organisations' }
]

const Navbar = () => {
  const history = useHistory()

  return (
    <NavbarContainer>
      <GoBackWrapper
        onClick={() => history.push('/')}
      >
        <Icon src={iconBack} />

        <GoBackTitle>
          Back
        </GoBackTitle>
      </GoBackWrapper>

      <Title>Settings</Title>

      <NavbarItems>
        {
          navbarItems.map((item, i) => (
            <NavLinkStyled
              key={i}
              activeClassName={activeItem}
              to={`${process.env.CHAT_PUBLIC_PATH}/settings/${item.route}`}
            >
              {item.title}
            </NavLinkStyled>
          ))
        }
      </NavbarItems>
    </NavbarContainer>
  )
}

export default Navbar
